module.exports = __webpack_public_path__ + "static/media/jnu_logo.6ce81cc9.png";